import { oc } from '@orpc/contract';
import { approvalSchema, decideApprovalInputSchema } from '../schemas/approvals.schemas.js';
/**
 * The administrator's decision, with the ceiling it raises the purchase to. `purchaseMax` defaults to the
 * offer that was asked for and may only be **lowered** — an approval is a limit, not a blank cheque.
 */
export const decideApprovalContract = oc
    .route({
    method: 'POST',
    path: '/approvals/{approvalId}/decide',
    tags: ['Approvals'],
    summary: 'Approve or reject an above-ceiling request (administrator)',
})
    .input(decideApprovalInputSchema)
    .output(approvalSchema);
//# sourceMappingURL=decide-approval.contract.js.map